import { connect } from 'react-redux';

import ComparePopupContainer from '../ComparePopup/ComparePopupContainer';
import {
  addProductToBasketFromComparePopup,
  removeProductFromPopup,
  removeAllProductsFromPopup
} from '../../reduck/listingPageComparePopup.reduck';
import {
  removeProductAndTriggerAnalytics
} from '../../reduck/listingPageComparison.reduck';


const mapStateToProps = (state) => ({
  loading: state.listingPage.comparePopup.loading,
  compareProductsData: state.listingPage.comparePopup.compareProductsData,
  addingProductToBasket: state.listingPage.comparePopup.addingProductToBasket
});

const mapDispatchToProps = (dispatch) => ({
  removeProductFromComparePopup: (productOrderInComparePopup, productId) => {
    dispatch(removeProductFromPopup(productOrderInComparePopup));

    // remove product also from compare panel and run analytics
    dispatch(removeProductAndTriggerAnalytics(productId, 'ComparePopup'));
  },

  removeAllProductsFromComparePopup: () => {
    dispatch(removeAllProductsFromPopup());
  },
  addProductToBasketFromComparePopup: (productId) => {
    dispatch(addProductToBasketFromComparePopup(productId));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ComparePopupContainer);
